<template>
    <ui-create
        name="groupPreference"
        :title="title"
        :load="load"
    >
        <template #body >

                <v-form ref="form" >
                    <v-row>
                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-text-field
                                label="Descrição"
                                v-model="form.descricao"
                                counter
                                maxlength="32"
                                :rules="[
                                    form_descricao_rules.required, form_descricao_rules.counter,
                                        form_descricao_rules.min
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-autocomplete
                                label="Grupo"
                                v-model="form.id_grupo"
                                :items="sections"
                                item-text="descricao"
                                item-value="id"
                                :rules="[form_grupo_rules.required]"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <vuetify-money
                                label="Valor"
                                v-model="form.valor"
                                v-bind:options="options_form_valor"
                                    :rules="[form_valor_rules.required, form_valor_rules.counter]"
                            ></vuetify-money>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-checkbox
                                label="Ativo?"
                                v-model="form.ativo"
                                true-value="s"
                                false-value="n"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                </v-form>
        </template>
    </ui-create>
</template>
<script>
import uiCreate from '@/templates/create'
export default {
    name: 'vwgroupPreferenceCreate',
    components: {
        uiCreate
    },
    data(){
        return {
            load: false,
            form: {
                descricao: '',
                id_grupo: null,
                valor: '',
                ativo: null
            },

            sections: [],

            form_descricao_rules: {
                required: value => !!value || 'Descrição é obrigatória.',
                counter: value => value.length <= 32 || 'Dados inválido!',
                min: v => v.length >= 2 || 'Mínimo de 2 caracteres'
            },

            form_grupo_rules: {
                required: value => !!value || 'Selecione um grupo.'
            },

            options_form_valor: {
                prefix: "R$",
                length: 4,
                precision: 2
            },
            form_valor_rules: {
                required: value => !!value || 'Valor é obrigatório.',
                counter: value => value.length <= 5 || 'Dados inválido!'
            }
        }
    },

    computed:{
        id: function(){
            return this.$route.params.id
        },

        title(){
            return this.id ? `Editar Preferencia de Grupo: ${this.id}` : 'Cadastrar Preferencia de Grupo'
        }
    },

    methods: {
        clearForm: function() {
            for (let prop in this.form) {
                this.form[prop] = ''
            }
        },
    
        save: function(){
            this.load = true
            if(this.id !== undefined){
                this.update()
            }else{
                this.create()
            }
        },

        update: function(){
            this.load = true
            fetch(process.env.VUE_APP_API + '/group-pref/update/' + this.id, {
                method: 'PUT',
                headers: new Headers({
                    'Authentication': this.$store.getters.token,
                    'Data': JSON.stringify(this.form)
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.returnRead()
                })
                .catch(error => {
                    console.error(error)
                    this.alert = {
                        text: 'Erro interno ao atualizar a preferencia de grupo!',
                        show: true,
                        type: 'red darken-1'
                    }
                })
                .finally(() => {
                    this.load = false
                })
        },

        create: function(){
            this.load = true
            fetch(process.env.VUE_APP_API + '/group-pref/create', {
                method: 'POST',
                headers: new Headers({
                    'Authentication': this.$store.getters.token,
                    'Data': JSON.stringify(this.form)
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.alertSuccess = {
                        text: 'Preferencia de Grupo cadastrado com sucesso.',
                        show: true,
                        type: 'red darken-1'
                    }
                    this.clearForm()
                })
                .catch(error => {
                    console.error(error)
                    this.alert = {
                        text: 'Erro interno ao gravar a preferencia de grupo!',
                        show: true,
                        type: 'red darken-1'
                    }
                })
                .finally(() => {
                    this.load = false
                })
        },

        getData: function(){
            this.load = true
            fetch(process.env.VUE_APP_API + '/group-pref/read/' + this.id, {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.$store.getters.token
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.form = resJSON.response[0].listhelper[0]
                })
                .catch(error => {
                    console.error(error)
                })
                .finally(() => {
                    this.load = false
                })
        },

        getSections: function(){
            fetch(process.env.VUE_APP_API + '/generics/description/grupos', {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.$store.getters.token
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.sections = resJSON.response
                })
                .catch(error => {
                    console.error(error)
                })
        }
    },

    mounted(){
        if (this.id != undefined) {
            this.getData()
        }

        this.getSections()

        this.$root.$on('save-changes-on-groupPreference', () => {
            this.$nextTick(() => {
                this.save()
            })
        })
    }
}
</script>